module.exports = __webpack_public_path__ + "img/chat.d594ff37.svg";